/**
 * Tracking touchPoint constants
 * Used to identify where user interactions occur in the application
 */
export const TRACKING_TOUCH_POINTS = {
  KICKSTART_SCREEN_V2: 'Kickstart screen v2',
}
